import { isTabIsolationEnabled } from "@/store/tabStore/identity";

/** One-way latch: `whenReady()` pends until `markReady()` opens it. */
export type ReadyGate = {
  whenReady: () => Promise<void>;
  markReady: () => void;
  isReady: () => boolean;
};

/** `openFromStart` builds a gate that never makes callers wait. */
export const createReadyGate = (openFromStart = false): ReadyGate => {
  let isOpen = openFromStart;
  let openGate: () => void;
  const opened = new Promise<void>((resolve) => {
    openGate = resolve;
  });

  return {
    whenReady: () => (isOpen ? Promise.resolve() : opened),
    markReady: () => {
      if (isOpen) return;
      isOpen = true;
      openGate();
    },
    isReady: () => isOpen
  };
};

/**
 * Boot gate of the tab storage layer: `tabStorage` waits on it, `initTabStorage()`
 * opens it. Starts open when the feature is OFF — nothing to migrate, so callers
 * that skip `initTabStorage()` can't hang.
 */
export const tabStorageReadyGate = createReadyGate(!isTabIsolationEnabled);
